import { AppointmentEventDto, VisitCardLineStyleDto } from '@lmt/shared-types';
import React, { FC, useCallback } from 'react';
import styles from './MonthAppointmentPopup.module.scss';
import { AppointmentPatientInfo } from '../components/types';
import { AppointmentPopup } from '../components/AppointmentPopup';
import { useAppointmentResourceDetails } from './ResourceViewAppointment';
import { getLongMonthDateWithoutYear } from '../../../patients/common';
import type { AppointmentModel } from '@lmt/unicorn-shared/app/common/devexpress/Scheduler/dx-react-scheduler';

export type AppointmentInfo = AppointmentModel & {
  data: AppointmentEventDto;
  patient?: AppointmentPatientInfo;
  color: string;
  lineStyles: VisitCardLineStyleDto[];
  title: string;
  isAnonymized: boolean;
  subtenantCode: string;
  id: number | string;
};

interface Props {
  appointments: AppointmentInfo[];
  date: Date;
  handleClose?: () => void;
}

export const MonthAppointmentPopup: FC<Props> = (props) => {
  const { appointments, handleClose } = props;

  const renderAppointment = useCallback(
    (appointment: AppointmentInfo) => {
      const { doctor, room, specialConditions } = useAppointmentResourceDetails(
        appointment.data,
      );
      return (
        <div key={appointment.data.id} className={styles.item}>
          <AppointmentPopup
            key={appointment.data.id}
            appointmentData={appointment.data}
            patient={appointment.patient}
            subtenantCode={appointment.subtenantCode}
            doctor={doctor}
            room={room}
            hideDate={true}
            resources={specialConditions}
            onClose={handleClose}
          />
        </div>
      );
    },
    [appointments],
  );

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {getLongMonthDateWithoutYear(props.date)}
      </div>
      <div className={styles.items}>
        {appointments
          .sort((a, b) => (a.startDate > b.startDate ? 1 : -1))
          .map((appointment) => {
            return renderAppointment(appointment);
          })}
      </div>
    </div>
  );
};
